module.exports = __webpack_public_path__ + "images/pages/lp/bulk_estimate_guide_4_be43247e541294520e86a2a242886d88.png";